import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_SnackBar = _resolveComponent("SnackBar")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SnackBar, { store: _ctx.store }, null, 8, ["store"]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmResubmitRequest",
      modalOpened: true
    }, null, 512),
    _createVNode(_component_router_view)
  ], 64))
}